import TCascading from './main'

/* istanbul ignore next */
TCascading.install = Vue => {
  Vue.component(TCascading.name, TCascading)
}

export {
  TCascading
}



// WEBPACK FOOTER //
// ./src/module/new-cascader/index.js